import React, { useEffect, useState } from 'react';
import api from '~/services/api';
import { Label, Input, Select, TextArea } from '~/componentes/CustomForm';
// import CheckBox from '~/componentes/CustomForm/Check/styles/CheckBox';

import { Container, SecaoTicket, ItemTicket } from './styles';
// import CustomScrollBar from '~/componentes/CustomScrollBar';
import { Materialize } from '~/styles/materializeGrid';
// import { SLModalFooter } from '~/pages/Sistema/componentes/SistemaList';
import ShowConfirmacao from '~/utils/ShowConfirmacao';
// import Acoordion from '~/componentes/Acoordion';
// import Button from '~/componentes/Button';
// import IconLixeira from '~/assets/icones/IconLixeira.svg';

function CreateContent({ mountedData }) {
  const [status, setStatus] = useState([
    { id: 'A', titulo: 'Aprovado' },
    { id: 'R', titulo: 'Reprovado' },
  ]);
  const [statusAprovacao, setStatusAprovacao] = useState('A');
  const [observacao, setObservacao] = useState(mountedData?.observacao);
  // const [projetos, setProjetos] = useState([]);
  // const [horarios, setHorarios] = useState([]);
  // const [ordemServicoAtividades, setOrdemServicoAtividades] = useState([]);
  const [tipo, setTipo] = useState(mountedData?.tipoOS);
  const [tickets, setTickets] = useState([]);
  const [totalHorasAnalistaDia, setTotalHorasAnalistaDia] = useState('00:00');

  useEffect(() => {
    if (mountedData?.id) {
      api
        .get('/signed/empresa/suporte/aprovarordemservico/totalhorasanalista', {
          params: { id: mountedData.id },
        })
        .then(response => {
          setTotalHorasAnalistaDia(formatarMinutosMascara(response?.data?.totalMinutos));
        });
    }
  }, [mountedData]);

  useEffect(() => {
    if (tipo == 'S') {
      let tickets = [];

      for (const item of mountedData.tickets) {
        let horarios = [];
        for (const itemHorario of item?.horarios ?? []) {
          horarios.push({
            idMovideskTime: 0,
            horaInicial: itemHorario?.horaInicial,
            horaFinal: itemHorario?.horaFinal,
            horaTrabalhada: itemHorario?.horaTotalMascara,
            totalHoraMinutos: itemHorario?.minHoraFin - itemHorario?.minHoraIni,
          });
        }

        const isComplementar =
          !item?.ticket ||
          !item?.ticketInteracao ||
          item?.titulo === 'Atividade Complementar de OS';

        tickets.push({
          tipo: isComplementar ? 'M' : 'A',
          check: false,
          idTicket: item?.idTicket,
          titulo: item?.titulo,
          cliente: item?.ticket?.nomeCliente || 'ERPWorks',
          idMovidesk: item?.ticket?.idMoviDesk,
          idMovideskAction: item?.ticketInteracao?.idMoviDesk,
          description: item?.descricao,
          htmlDescription: item?.descricaoHTML,
          totalHora: formatarMinutosMascara(item?.horaTotalMinuto),
          totalHoraMinutos: item?.horaTotalMinuto,
          posHorario: !!item?.posHorario,
          excluido: !!item?.excluido,
          horarios,
        });
      }

      setTickets(tickets);
    }
  }, [mountedData]);

  const formatarMinutosMascara = totalMinutos => {
    const minutos = parseFloat(totalMinutos || 0);
    const horas = parseInt(minutos / 60);
    const resto = Math.round(minutos % 60);
    return ('00' + horas).slice(-2) + ':' + ('00' + resto).slice(-2);
  };

  const totalHorasLancadas = formatarMinutosMascara(
    tickets
      .filter(item => !item?.excluido)
      .reduce((soma, item) => soma + parseFloat(item?.totalHoraMinutos || 0), 0),
  );
  const totalAtividadeSRP = formatarMinutosMascara(
    tickets
      .filter(item => item?.tipo === 'M' && !item?.excluido)
      .reduce((soma, item) => soma + parseFloat(item?.totalHoraMinutos || 0), 0),
  );
  const totalPosHorario = formatarMinutosMascara(
    tickets
      .filter(item => item?.posHorario && !item?.excluido)
      .reduce((soma, item) => soma + parseFloat(item?.totalHoraMinutos || 0), 0),
  );

  async function handleSubmit(data, options) {
    const { closeReload } = options || {};

    return ShowConfirmacao(
      async () => {
        let thisData = { statusAprovacao, id: mountedData?.id, observacao };

        let response = await api.put('/signed/empresa/suporte/aprovarordemservico', thisData);
        if (response?.status === 200) {
          closeReload && closeReload();
        }

        return response;
      },
      {
        errorModal: {
          defaultMessage: `Ocorreu um erro ao aprovar essa Ordem de Serviço, por favor, tente novamente mais tarde.`,
        },
        message: `Tem certeza que deseja aprovar essa Ordem de Serviço?`,
        successModal: `Ordem de Serviço aprovada com sucesso!`,
      },
    );
  }

  return (
    <Container onSubmit={handleSubmit} defaultScroll={true}>
      <Materialize className="materialize">
        <div className="row header">
          <p className="h-descricao">
            Preencha as informações corretamente, e se atente ao (*) pois são campos obrigatórios
          </p>
        </div>
        {tipo == 'P' ? (
          <div>
            <div className="aprov-header row no-margin">
              <div className="aprov-title">
                <span className="aprov-cod">#{mountedData?.id}</span>
                <h3>{mountedData?.titulo}</h3>
                <span className="badge-tipo badge-tipo-projeto">Projeto</span>
              </div>
              <Label title="Status Aprovação *" className="aprov-status">
                <Select
                  required="true"
                  isString
                  list={{ list: status, value: 'id', label: 'titulo' }}
                  name="statusAprovacao"
                  defaultValue={'A'}
                  firstOption
                  onChange={e => {
                    const v = e.currentTarget.value || 'A';
                    setStatusAprovacao(v);
                  }}
                />
              </Label>
            </div>

            <div className="aprov-info-grid row no-margin">
              <div className="info-item">
                <span className="info-label">Cliente</span>
                <span className="info-value">{mountedData?.cliente?.nomeFantasia}</span>
              </div>
              <div className="info-item">
                <span className="info-label">Projeto</span>
                <span className="info-value">{mountedData?.projeto?.titulo}</span>
              </div>
              <div className="info-item">
                <span className="info-label">Coordenador</span>
                <span className="info-value">{mountedData?.coordenador?.nome}</span>
              </div>
              <div className="info-item">
                <span className="info-label">Analista</span>
                <span className="info-value">{mountedData?.analista?.nome}</span>
              </div>
            </div>

            <div className="aprov-info-grid row no-margin">
              <div className="info-item">
                <span className="info-label">Emissão</span>
                <span className="info-value">
                  {
                    new Date(mountedData?.dataEmissao)
                      .toLocaleString('pt-BR', { timeZone: 'UTC' })
                      .split(',')[0]
                  }
                </span>
              </div>
              <div className="info-item">
                <span className="info-label">Hora Translado</span>
                <span className="info-value">{mountedData?.horaTranslado}h</span>
              </div>
              <div className="info-item">
                <span className="info-label">Hora Desconto</span>
                <span className="info-value">{mountedData?.horaDesconto}h</span>
              </div>
              <div className="info-item info-item-destaque">
                <span className="info-label">Total de Horas Lançadas</span>
                <span className="info-value">{mountedData?.horaTotal}h</span>
              </div>
            </div>

            {statusAprovacao === 'R' && (
              <div className="row no-margin">
                <Label title="Observação" className="col s12 m12 l12">
                  <TextArea
                    name="observacao"
                    required="true"
                    defaultValue={mountedData?.observacao}
                    onChange={e => {
                      const v = e.currentTarget.value || '';
                      setObservacao(v);
                    }}
                  />
                </Label>
              </div>
            )}

            <div className="row no-margin">
              <p className="title_p">Horários Lançados</p>
              <div className="horario">
                {mountedData?.horarios?.map((thisHora, a) => (
                  <div className="item-hora" key={a}>
                    <div className="card-numero">
                      <p className="numero">{a + 1}</p>
                    </div>
                    <div className="card-hora">
                      <p className="hora">
                        {thisHora?.horaInicialMascara} - {thisHora?.horaFinalMascara}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="row no-margin">
              <div className="col s12 m12 l12 no-padding">
                <p className="title_p">Atividades</p>
                {mountedData?.atividades?.map((thisAtividade, a) => (
                  <div className="row col s12 m12 l12" key={a}>
                    <div className="row item lateral no-margin">
                      <h5>Atividade: </h5>
                      <p>{thisAtividade?.titulo}</p>
                    </div>
                    <div className="row item no-margin">
                      <h5>Descrição </h5>
                      <p>{thisAtividade?.descricao}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        ) : (
          <div>
            <div className="aprov-header row no-margin">
              <div className="aprov-title">
                <span className="aprov-cod">#{mountedData?.id}</span>
                <h3>{mountedData?.titulo}</h3>
                <span className="badge-tipo badge-tipo-suporte">Suporte</span>
              </div>
              <Label title="Status Aprovação *" className="aprov-status">
                <Select
                  required="true"
                  isString
                  list={{ list: status, value: 'id', label: 'titulo' }}
                  name="statusAprovacao"
                  defaultValue={'A'}
                  firstOption
                  onChange={e => {
                    const v = e.currentTarget.value || 'A';
                    setStatusAprovacao(v);
                  }}
                />
              </Label>
            </div>

            <div className="aprov-info-grid row no-margin">
              <div className="info-item">
                <span className="info-label">Analista</span>
                <span className="info-value">{mountedData?.analista?.nome}</span>
              </div>
              <div className="info-item">
                <span className="info-label">Coordenador</span>
                <span className="info-value">{mountedData?.coordenador?.nome}</span>
              </div>

              <div className="info-item">
                <span className="info-label">Cliente</span>
                <span className="info-value">{mountedData?.cliente?.nomeFantasia}</span>
              </div>
              <div className="info-item">
                <span className="info-label">Projeto</span>
                <span className="info-value">{mountedData?.projeto?.titulo}</span>
              </div>
            </div>

            <div className="aprov-info-grid row no-margin">
              <div className="info-item">
                <span className="info-label">Emissão</span>
                <span className="info-value">
                  {
                    new Date(mountedData?.dataEmissao)
                      .toLocaleString('pt-BR', { timeZone: 'UTC' })
                      .split(',')[0]
                  }
                </span>
              </div>
              <div className="info-item">
                <span className="info-label">Hora Translado</span>
                <span className="info-value">{mountedData?.horaTranslado}h</span>
              </div>
              <div className="info-item">
                <span className="info-label">Hora Desconto</span>
                <span className="info-value">{mountedData?.horaDesconto}h</span>
              </div>
            </div>

            <div className="aprov-stats row no-margin">
              <div className="stat-card">
                <p className="stat-label">SRP Autorizado</p>
                <p className="stat-value">{totalPosHorario}</p>
              </div>

              <div className="stat-card">
                <p className="stat-label">Atividade SRP</p>
                <p className="stat-value">{totalAtividadeSRP}</p>
              </div>
              <div className="stat-card">
                <p className="stat-label">Total de Horas</p>
                <p className="stat-value">{totalHorasLancadas}</p>
              </div>
              <div className="stat-card">
                <p className="stat-label">Total do Analista no Dia</p>
                <p className="stat-value">{totalHorasAnalistaDia}</p>
              </div>
            </div>

            {statusAprovacao === 'R' && (
              <div className="row no-margin">
                <Label title="Observação" className="col s12 m12 l12">
                  <TextArea
                    name="observacao"
                    required="true"
                    defaultValue={mountedData?.observacao}
                    onChange={e => {
                      const v = e.currentTarget.value || '';
                      setObservacao(v);
                    }}
                  />
                </Label>
              </div>
            )}

            <div className="row">
              <div className="col s12 m12 l12">
                <div className="content-top col s12 m12 l12">
                  <p className="title_p">Atividades *</p>
                </div>
                <div className="col s12 m12 l12">
                  <ItemTicket item={false}>
                    <div className="col s1 m1 l2">
                      <p className="text-col">Id</p>
                    </div>
                    <div className="col s1 m1 l1">
                      <p className="text-col">Sq</p>
                    </div>
                    <div className="col s3 m3 l3">
                      <p className="text-col">Cliente</p>
                    </div>
                    <div className="col s5 m5 l5">
                      <p className="text-col">Titulo Ticket</p>
                    </div>
                    <div className="col s2 m2 l1">
                      <p className="text-col" style={{ textAlign: 'right', width: '100%' }}>
                        Total
                      </p>
                    </div>
                  </ItemTicket>
                  <div className="content-atividade">
                    {tickets?.map((item, index) => (
                      <SecaoTicket key={index} excluido={item?.excluido}>
                        <ItemTicket
                          item={true}
                          excluido={item?.excluido}
                          onClick={() => {
                            setTickets(
                              tickets.map((itemTicket, itemIndex) =>
                                itemIndex === index
                                  ? { ...itemTicket, check: !itemTicket?.check }
                                  : itemTicket,
                              ),
                            );
                          }}
                        >
                          <div className="col s1 m1 l2">
                            <p className="text-col">
                              {item?.idMovidesk ? `#${item?.idMovidesk}` : '-'}
                            </p>
                          </div>
                          <div className="col s1 m1 l1">
                            <p className="text-col">{item?.idMovideskAction || '-'}</p>
                          </div>
                          <div className="col s4 m4 l3">
                            <p className="text-col">{item?.cliente}</p>
                          </div>
                          <div className="col s5 m5 l5">
                            <p className="text-col titulo-com-badge">
                              {item?.titulo}
                              {item?.tipo === 'M' && <span className="badge-srp">SRP</span>}
                              {item?.posHorario && (
                                <span className="badge-pos">SRP Autorizado</span>
                              )}
                            </p>
                          </div>
                          <div className="col s2 m2 l1">
                            <p className="text-col" style={{ textAlign: 'right', width: '100%' }}>
                              {item?.totalHora}
                            </p>
                          </div>
                        </ItemTicket>
                        {item?.check == true && (
                          <div className="atv-content-body">
                            <div className="col s12 m6 l6">
                              <p
                                className={
                                  item?.htmlDescription ? 'item-desc' : 'item-desc no-html'
                                }
                              >
                                <div
                                  dangerouslySetInnerHTML={{
                                    __html: item?.htmlDescription
                                      ? item?.htmlDescription
                                      : item?.description,
                                  }}
                                ></div>
                              </p>
                            </div>
                            <div className="col s12 m6 l6">
                              {item?.horarios?.map((itemHorario, index) => (
                                <div className="item-horario" key={index}>
                                  <div className="row">
                                    <Label title="Inicial" className="col s6 m6 l6">
                                      <Input
                                        type="time"
                                        name="horaInicial"
                                        disabled="true"
                                        value={itemHorario?.horaInicial}
                                        style={{ fontSize: '0.9em' }}
                                      />
                                    </Label>
                                    <Label title="Final" className="col s6 m6 l6">
                                      <Input
                                        type="time"
                                        name="horaFinal"
                                        disabled="true"
                                        value={itemHorario?.horaFinal}
                                        style={{ fontSize: '0.9em' }}
                                      />
                                    </Label>
                                  </div>
                                </div>
                              ))}
                            </div>
                          </div>
                        )}
                      </SecaoTicket>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </Materialize>
    </Container>
  );
}

export default CreateContent;
